import { render, staticRenderFns } from "./ChatterDrawerLegacy.vue?vue&type=template&id=78517742"
import script from "./ChatterDrawerLegacy.vue?vue&type=script&lang=js"
export * from "./ChatterDrawerLegacy.vue?vue&type=script&lang=js"
import style0 from "./ChatterDrawerLegacy.vue?vue&type=style&index=0&id=78517742&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports